import validate from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45token_45global from "/opt/build/repo/middleware/auth-token.global.ts";
import manifest_45route_45rule from "/opt/build/repo/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45token_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}